export default "__VITE_ASSET__e394d51a__"